import ReactGA from 'react-ga';
function fireGAEvent(category, action, label, value) {
    ReactGA.event({
        category,
        action,
        label,
        value,
    });
}
export default fireGAEvent;
//# sourceMappingURL=fireGAEvent.js.map